<template>
  <div>
    <Card>

      <Row class="search-con">
        <Col span="24">

          <label class="search-label" >平台</label>
          <Select v-model="live_id" class="search-input" @on-change="liveTypeChange" clearable> 
            <Option
              v-for="item in liveIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
          <label class="search-label" >分类</label>
          <Select v-model="classify_id" class="search-input" @on-change="classifyChange" clearable> 
            <Option
              v-for="item in classifyIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>

          <label class="search-label" >标签</label>
          <Select v-model="tag_id" class="search-input" clearable> 
            <Option
              v-for="item in tagIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>

          <label class="search-label">负责人</label>
          <Select v-model="user" class="search-input" clearable filterable>
            <Option
              v-for="item in userIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>

          <label class="search-label" >标签状态</label>
          <Select v-model="tag_status" class="search-input" clearable> 
            <Option
              v-for="item in tagStatusIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>

          <label class="search-label" >是否黑名单</label>
          <Select v-model="is_black" class="search-input" clearable> 
            <Option
              v-for="item in blacks"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>


          <Button @click="handleSearch" type="primary" style="margin-left: 20px;">搜索</Button>
          <Button @click="handDelete" type="error" style="margin-left: 50px;">删除</Button>

          <Button @click="handConfirmTag" type="primary" style="margin-left: 50px;">确认标签</Button>
        </Col>
      </Row>

      <tables
        editable
        :columns="columns"
        v-model="tableData"
        :loading="tableLoading"
        @on-selection-change="changeId"
      />
      <Row class="page-con">
        <div class="page-bottom">
          <Page
            :current="page"
            :total="total"
            :page-size="pageSize"
            :page-size-opts="[10, 20, 30, 40, 100]"
            show-sizer
            show-elevator
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </Row>
    </Card>

    <Modal
      :mask-closable="false"
      v-model="editModal"
      title="编辑标签"
      footer-hide
      >
      <forms :resetFlag="resetFlag"
      ref="editFlower"  
      @on-ok="editSumit" @on-cancel="cancel" />
    </Modal>

    <Modal
      :mask-closable="false"
      v-model="editUserModal"
      title="修改负责人"
      footer-hide
      >
      <forms_ :resetFlag="resetFlag"
      ref="editUser"  
      @on-ok="editUserSumit" @on-cancel="cancel" />
    </Modal>

  </div>
</template>

<script>
import Tables from "_c/tables/table-only.vue";
import Forms from "./edit_flower_form.vue";
import Forms_ from "./edit_user_form.vue";

import { listFlower, userBlack, editUserTag, getClassifyTag, deleteFollowers, confirmTags, getLiveType, getClassifys, getStrategyUser, changeFollower} from "@/api/data";
export default {
  name: "finance",
  components: {
    Tables,
    Forms,
    Forms_,
  },
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 10,
      addModal: false,
      editModal: false,
      editUserModal: false,
      resetFlag: false,
      editData: {},
      tableLoading: true,
      allMoney: 0.0,
      classify_id:0,
      live_id:0,
      selectId:[],
      tagIds:[],
      tag_id:'',
      tag_status:'',
      tagStatusIds:[{id: 1, name:"已确认"}, {id: 0, name:"未确认"}],
      blacks:[{id: 1, name:"是"}, {id: 0, name:"否"}],
      is_black:'',
      classifyIds:[],
      userIds:[],
      user:0,
      startTime: "",
      endTime: "",
      dy_id:'',
      liveIds:[],
      columns: [
        {type: "selection",width: 60,align: "center", align: "center"},
        { title: "用户名" , key: "username", editable: true },
        { title: "用户签名" , key: "signature", editable: true,
        render: (h, params) => {
              return h('div', [
              // 显示的位置上方
                h('Tooltip', {
                  props: { placement: 'top' ,transfer: true}
                }, [
                  h('span', {
                    style: {
                      display: 'inline-block',
                      width: '70px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    },
                  }, params.row.signature),
                  // 显示的内容
                  h('span', {
                    slot: 'content',
                    style: { whiteSpace: 'normal', wordBreak: 'break-all' }
                  },params.row.signature)
                ])
              ])
            } },
        { title: "平台" , key: "live", editable: true },
        { title: "所属分类" , key: "classify_name", editable: true,
        render: (h, params) => {
            var texts = params.row.classify_name_
            if (texts == null){
              texts = params.row.classify_name
            }
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
          }},
        { title: "所属标签" , key: "tag_", editable: true,
        render: (h, params) => {
            var texts = params.row.tag_
            if (texts == null){
              texts = params.row.tag
            }
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
          }},
        { title: "链接地址" , key: "url", editable: true,
        render: (h, params) => {
            return params.row.url != '' ? h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.download(params.row.url);
                    },
                  },
                },
                "查看"
              )
            ]) : h('span', '');
          }},
        {
          title: "是否已经人工确认过标签",
          key: "_update",
          render: (h, params) => {
            var texts = ""
            if (params.row._update){
              texts = "已确认"
            }else{
              texts = "未确认"
            }
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
          },
        }, {
          title: "是否关注",
          key: "follower",
          render: (h, params) => {
            var texts = ""
            if (params.row.follower > 0){
              texts = "已关注"
            }else{
              texts = "未关注"
            }
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
          },
        },
        {
          title: "黑名单",
          key: "_black",
          render: (h, params) => {
            return h("div", [
              h("i-switch", {
                props: {
                  type: "primary",
                  value: params.row._black === true,
                },
                style: {
                  marginRight: "5px",
                },
                on: {
                  "on-change": (value) => {
                    this.changeUserStatus(value, params);
                  },
                },
              }),
            ]);
          },
        },  
        { title: "负责人" , key: "dy_username", editable: true },  
        { title: "浏览时间" , key: "pre_browse_time", editable: true }, 
        { title: "创建时间" , key: "create_time", editable: true },  
        {
          title: "Handle",
          key: "handle",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                 type:"primary",
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.showEditUserModal(params);
                    },
                  },
                },
                "修改负责人"
              ), h(
                "Button",
                {
                 type:"primary",
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.showEditModal(params);
                    },
                  },
                },
                "修改标签"
              )
            ]);
          },
        }
      ],
      tableData: [],
    };
  },
  methods: {
    download(url) {
      window.open(url, '_blank');
    },
    showEditUserModal(params) {
      this.editUserModal = true
      this.editData = params.row;
      var params = {
        live_id: params.row.live_id,
        classify_id: params.row.dy_classify_id
      }
      getStrategyUser(params).then((res) => {
        var users = res.data.data.records;
        var data = new Array()
        for (var i = 0; i < users.length; i++) {
          data[i] = { key: users[i].dy_id, label: users[i].username }
      }
        this.$refs.editUser.setUserData(data)
      });

      this.$refs.editUser.setEditData(this.editData)

    },liveTypeChange(value){
      if (value == undefined){
        return
      }
      this.live_id = value
      this.getStrategyUserData()

    },classifyChange(value){
      if (value == undefined){
        return
      }
      this.classify_id = value
      this.getStrategyUserData()
      this.getClassifyTagData()

    },getClassifyTagData(){
      var params = {
          classify_id: this.classify_id
        }
        getClassifyTag(params).then((res) => {
        var tagIds = res.data.data.records;
        var data = new Array()
        for (var i = 0; i < tagIds.length; i++) {
          data[i] = { id: tagIds[i].id.toString(), name: tagIds[i].tag}
        }
        this.tagIds = data
        });
    }
    ,getStrategyUserData(){
      var params_ = {
        live_id: this.live_id,
        classify_id: this.classify_id
      }
      getStrategyUser(params_).then((res) => {
        var users = res.data.data.records;
        var data = new Array()
        for (var i = 0; i < users.length; i++) {
          data[i] = { id: users[i].dy_id, name: users[i].username }
      }
        this.userIds = data
      });
    },
    showEditModal(params) {
      this.editData = params.row;
      this.editModal = true;
      var params = {
          classify_id: params.row.dy_classify_id,
          live_id: params.row.live_id
        }
        getClassifyTag(params).then((res) => {
        var tagIds = res.data.data.records;
        var data = new Array()
        for (var i = 0; i < tagIds.length; i++) {
          data[i] = { id: tagIds[i].id.toString(), name: tagIds[i].tag}
        }
        this.$refs.editFlower.setTagData(data)
        });

      this.$refs.editFlower.setEditData(this.editData)
    },
    changeUserStatus(value, params){
      let data = new FormData();
      data.append("black", value);
      userBlack(data, params.row.id).then((res) => {
        if (res.data.code == 200) {
          this.$Message.success("成功!");
        } else {
          this.$Message.error(res.data.msg);
        }
      });

    }, editUserSumit(formValidate){
      let data = new FormData();
      var ids = [formValidate.id]
      data.set("id", formValidate.user_id);
      data.set("ids", ids);
      changeFollower(data)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.editUserModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });

    }, editSumit(formValidate) {
      let data = new FormData();
      data.set("ids", [formValidate.id]);
      data.set("tag_id", formValidate.tag_id);
      editUserTag(data)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.editModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    cancel() {},
    changePage(page) {
      this.page = page;
      this.handleSearch();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.handleSearch();
    }, changeId(selection) {
      this.selectId = [];
      for (let i = 0; i < selection.length; i++) {
        this.selectId[i] = selection[i].id;
      }
    }, handConfirmTag(){
      if (this.selectId.length == 0) {
        this.$Message.warning("请选择其中一条");
        return;
      }

      this.$Modal.confirm({
          title: '提示',
          content: '<p>是否二次确认标签？</p>',
          onOk: () => {
            let data = new FormData();
            data.set('ids', this.selectId)
            confirmTags(data)
              .then((res) => {
                  if (res.data.code == 200) {
                      this.handleSearch()
                      this.$Message.success("成功!");
                  } else {
                      this.$Message.error(res.data.msg);


                  }
              }).catch((err) => {
                  this.$Message.error("失败!");
              });
          },
          onCancel: () => {
              this.$Message.info('已取消');
          }
      });

    }, handDelete(){
      if (this.selectId.length == 0) {
        this.$Message.warning("请选择其中一条");
        return;
      }
      this.$Modal.confirm({
          title: '提示',
          content: '<p>是否删除</p>',
          onOk: () => {
            let data = new FormData();
            data.set('ids', this.selectId)
            deleteFollowers(data)
              .then((res) => {
                  if (res.data.code == 200) {
                      this.handleSearch()
                      this.$Message.success("成功!");
                  } else {
                      this.$Message.error(res.data.msg);
                  }
              }).catch((err) => {
                  this.$Message.error("失败!");
              });
          },
          onCancel: () => {
              this.$Message.info('已取消');
          }
      });

    },
    handleSearch() {
      this.setTableLoading(true);
      let params = {
        page: this.page,
        pageSize: this.pageSize,
        classify_id: this.classify_id,
        live_id: this.live_id,
        status: this.tag_status,
        user_id: this.user,
        black:this.is_black,
        tag_id: this.tag_id
      };
      listFlower(params).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.setTableLoading(false);
      });
    },
    setTableLoading(state) {
      this.tableLoading = state;
    },
  },
  mounted() {
    this.dy_id = this.$route.query.id;
    this.classify_id = this.$route.query.classify_id;

    getLiveType({}).then((res) => {
        if (res.data.code == 200) {
          var lives = res.data.data;
          var data = new Array()
          for (var i = 0; i < lives.length; i++) {
            data[i] = { id: lives[i].id.toString(), name: lives[i].name }
          }
          this.liveIds = data
          }
      }); 

    getClassifys().then((res) => {
      var classify_list = res.data.data.records;
      var data = new Array()
      for (var i = 0; i < classify_list.length; i++) {
        data[i] = { id: classify_list[i].id.toString(), name: classify_list[i].name }
      }
      this.classifyIds = data
    });

    this.handleSearch();

  },
};
</script>
